import { branchRoutes } from '@/lib/route-paths';
import { createFileRoute, redirect } from '@tanstack/react-router';

/** Next `step-configure` pushes here; list UI lives under `/dashboard/content/videos`. */
export const Route = createFileRoute(
  '/_authed/dashboard/l/$locationId/videos/'
)({
  // `branchRoutes`, not `useBranchRoutes()`: `beforeLoad` runs outside render,
  // where a hook throws instead of redirecting.
  beforeLoad: ({ params }) => {
    throw redirect({ to: branchRoutes(params.locationId).contentGallery });
  },
});
